import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../../components/MaterialTypography";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../../components/MaterialInput";
import { Delete } from "@mui/icons-material";
import MaterialButton from "../../../../components/MaterialButton";
import { useEffect, useState } from "react";
import MaterialSelect from "../../../../components/MasterSelect";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import {
  allDeliveries,
  createDeliveryMutation,
  getAllProducts,
  getDeliveryById,
  unassignedSalesOrders,
  unassignedSalesOrdersById,
} from "../graphQl";
import { useLoading } from "../../../../context/LodingContext";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import Swal from "sweetalert2";

const DeliveryForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const formType = location?.state?.type;
  const rowId = location?.state?.rowId;
  const todayDate = new Date();
  const pad = (n) => String(n).padStart(2, "0");

  const today = `${todayDate.getFullYear()}-${pad(
    todayDate.getMonth() + 1
  )}-${pad(todayDate.getDate())}T${pad(todayDate.getHours())}:${pad(
    todayDate.getMinutes()
  )}`;

  const { userId } = useAuthData();
  const [productOptions, setProductOptions] = useState([]);
  const [deliveryOptions, setDeliveryOptions] = useState([]);

  const [soNumberOptions, setSONumberOptions] = useState([]);
  const [deliveryList, setDeliveryList] = useState([]);
  const [inputDisable, setInputDisable] = useState(false);
  const [deliveryData, setDeliveryData] = useState({
    deliveryId: "",
    salesOrderId: "",
    customerName: "",
    customerAddress: "",
    location: "",
    contactPerson: "",
    contactNumber: "",
    deliveryDate: "",
    role: "",
    deliveryAgent: "",
  });

  const [productData, setProductData] = useState([
    {
      productName: "",
      productCode: "",
      quantity: "",
    },
  ]);

  //UseEffect to fetch Product Options
  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        const response = await request(BASEURL, getAllProducts);
        const responseData = response.allProducts.data;

        const products = responseData?.map((product) => ({
          label: product.productName,
          value: product.productCode,
        }));
        console.log("products", products);

        setProductOptions(products);
      } catch (error) {
        console.error("Error Fetching Data:", error);
      }
    };
    const fetchDeliveryEmployee = async () => {
      try {
        const response = await request(BASEURL, allDeliveries);
        const responseData = response.allUsers;        

        const deliveries = responseData?.map((employee) => ({
          label: employee.employeeName + " - " + employee.employeeCode,
          value: employee.employeeCode,
          role: employee.role?.role ?? "",
          agentId: employee.id,
        }));

        setDeliveryOptions(deliveries);
      } catch (error) {
        console.error("Error Fetching Data", error);
      }
    };
    fetchAllProducts();
    fetchDeliveryEmployee();
  }, []);

  //

  useEffect(() => {
    fetchunassignedSalesOrders();
  }, []);

  const fetchunassignedSalesOrders = async () => {
    try {
      const response = await request(BASEURL, unassignedSalesOrders);

      const res = response?.unassignedSalesOrders?.data;

      const salesOrder = res?.map((sales) => ({
        label: sales?.orderSio,
        value: sales?.id,
      }));

      setSONumberOptions(salesOrder);
    } catch (err) {
      console.error("Error Fetching Data", err);
    } finally {
    }
  };

  //UseEffect to set Page type
  useEffect(() => {
    if (formType == "view") {
      setInputDisable(true);
    } else {
      setInputDisable(false);
    }
  }, [formType]);

  //fetch data by ID
  useEffect(() => {
    if (!rowId) return;
    const fetchDeliveryDataById = async () => {
      try {
        setCirleLoading(true);
        const response = await request(BASEURL, getDeliveryById, {
          id: rowId,
        });

        const responseData = response.getDeliveryById.data[0];

        if (responseData) {
          setDeliveryData((prev) => ({
            ...prev,
            deliveryId: responseData.deliveryId || "",
            salesOrderId: responseData.salesOrder.soNumber
              ? {
                  label: responseData.salesOrder.soNumber,
                  value: responseData.salesOrder.soNumber,
                }
              : "",
            customerName: responseData?.customerName || "",
            customerAddress: responseData?.customerAddress || "",
            contactPerson: responseData.contactPerson || "",
            contactNumber: responseData.contactNumber || "",

            deliveryDate: responseData.deliveredDate
              ? new Date(responseData.deliveredDate).toISOString().slice(0, 10)
              : "",
            deliveryAgent: responseData.repName
              ? { label: responseData.repName, value: responseData.repCode }
              : "",
            role: responseData.repRole,
            roleStatus: responseData.repRole ? "success" : "unchecked",
            deliveryIdStatus: responseData.deliveryId ? "success" : "unchecked",
            salesOrderIdStatus: responseData.salesOrder
              ? "success"
              : "unchecked",
            customerNameStatus: responseData.customerName
              ? "success"
              : "unchecked",
            customerAddressStatus: responseData?.customerAddress
              ? "success"
              : "unchecked",
            contactPersonStatus: responseData.contactPerson
              ? "success"
              : "unchecked",
            contactNumberStatus: responseData.contactNumber
              ? "success"
              : "unchecked",
            deliveryDateStatus: responseData.deliveredDate
              ? "success"
              : "unchecked",
            deliveryAgentStatus: responseData.repName ? "success" : "unchecked",
          }));
          const transformedProducts = (responseData.deliveryProducts || []).map(
            (product) => ({
              productName: { value: product.id, label: product.productName },
              productCode: product.productCode || "",
              quantity: product.quantity || 0,
            })
          );

          setProductData(transformedProducts);
        }
      } catch (error) {
        console.error("Error Fetching data", error);
      } finally {
        setCirleLoading(false);
      }
    };
    fetchDeliveryDataById();
  }, [rowId]);

  //Handle Delivery Submit Function
  const handleSubmit = async () => {
    setCirleLoading(true);
    try {
      const values = {
        userId: userId,
        deliveryAgentId: Number(deliveryData.deliveryAgent?.agentId),
        salesOrder: deliveryData.salesOrderId?.label,
        repName: deliveryData.deliveryAgent?.label || "",
        repCode: deliveryData.deliveryAgent?.value,
        customerName: deliveryData.customerName,
        customerAddress: deliveryData.customerAddress,
        deliveredDate: deliveryData.deliveryDate?.slice(0, 10),
        // deliveredOn: deliveryData.deliveryDate,
        visitStatus: "Pending",
        reason: "",
        paymentMode: "",
        contactPerson: deliveryData.contactPerson,
        contactNumber: deliveryData.contactNumber,
        // products: productData,
        // products: productData.map((p) => ({
        //   productCode: p.productCode,
        //   productName:
        //     typeof p.productName === "object"
        //       ? p.productName.label
        //       : p.productName,
        //   quantity: Number(p.quantity) || 0,
        // })),
      };
      const response = await request(BASEURL, createDeliveryMutation, {
        input: values,
      });

      const successStatus = response.createDelivery.success;
      const responseMessage = response.createDelivery.message;
      if (successStatus) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: responseMessage,
          showConfirmButton: true,
        }).then(() => {
          navigate("/Manage-Deliveries");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: responseMessage,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Error Submitting Data: ", error);
    } finally {
      setCirleLoading(false);
    }
  };

  //Handle Delivery Update Function
  const handleUpdate = async () => {
    setCirleLoading(true);
    try {
      const values = {
        id: rowId,
        userId: userId,
        salesOrder: deliveryData.salesOrderId,
        repName: deliveryData.deliveryAgent.label,
        repCode: deliveryData.deliveryAgent.value,
        customerName: deliveryData.customerName,
        customerAddress: deliveryData.customerAddress,
        deliveredDate: deliveryData.deliveryDate,
        deliveredOn: deliveryData.deliveryDate,
        visitStatus: "Pending",
        reason: "",
        paymentMode: "",
        contactPerson: deliveryData.contactPerson,
        contactNumber: deliveryData.contactNumber,
        products: productData,
      };

      console.log(values, "values");
    } catch (error) {
      console.error("Error Updating Data:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  //Handle Add Product Function
  const handleAddProduct = () => {
    setProductData([
      ...productData,
      {
        productName: "",
        productCode: "",
        quantity: "",
      },
    ]);
  };

  //Handle Remove Product Function
  const handleRemoveProduct = (index) => {
    const updated = [...productData];
    updated.splice(index, 1);
    setProductData(updated);
  };

  //Handle Change for all fields except Products
  const handleChange = async (event, selectEvent) => {
    let deliveryState = { ...deliveryData };
    console.log(event, selectEvent, "selectEvent");

    if (event?.target === undefined && selectEvent) {
      // Handling MaterialSelect
      switch (selectEvent.name) {
        case "deliveryAgent": {
          const value = event?.value ?? "";
          const alphaNLenghthRegex = new RegExp(
            "^([A-Za-z0-9\\s@#\\$%\\^&\\*\\(\\)_\\+\\-=\\[\\]\\{\\};:'\"`~,.<>\\/?!\\\\|]{1,30})$"
          );

          deliveryState.deliveryAgent = event;
          deliveryState.deliveryAgentStatus = alphaNLenghthRegex.test(value)
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          const selectedDriver = event.role;

          deliveryState.role = selectedDriver;
          setDeliveryData({
            ...deliveryData,
            role: selectedDriver,
            roleStatus: selectedDriver != "" ? "success" : "unchecked",
          });
          break;
        }
        case "salesOrderId": {
          const value = event?.value ?? "";
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,50})$");
          deliveryState.salesOrderId = event;
          deliveryState.salesOrderIdStatus = alphaNLenghthRegex?.test(value)
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          try {
            const response = await request(BASEURL, unassignedSalesOrdersById, {
              id: Number(event?.value),
            });

            const salesorder = response?.unassignedSalesOrdersById?.data[0];

            if (salesorder) {
              deliveryState.customerName = salesorder?.customerName ?? "";
              deliveryState.customerAddress = salesorder?.customerAddress ?? "";

              deliveryState.deliveryDate = salesorder?.deliveryDate ?? "";

              deliveryState.customerNameStatus = salesorder.customerName
                ? "success"
                : "unchecked";
              deliveryState.customerAddressStatus = salesorder.customerAddress
                ? "success"
                : "unchecked";

              deliveryState.deliveryDateStatus = salesorder.deliveryDate
                ? "success"
                : "unchecked";

              const productsdata = Array.isArray(salesorder?.products)
                ? salesorder.products.map((item) => ({
                    productName: {
                      label: item.productName ?? "",
                      value: item.productName ?? "",
                    },
                    quantity: item.quantity ?? 0,
                  }))
                : [];
              setProductData(productsdata);
            }
          } catch (err) {
            console.error(err);
          } finally {
          }

          break;
        }
      }
    } else if (event?.target) {
      // Handling MaterialInput
      const { name, value } = event.target;
      switch (name) {
        case "deliveryId": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,50})$");
          deliveryState[name + "Status"] = alphaNLenghthRegex.test(value.trim())
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          break;
        }

        case "customerName": {
          const alphaNLenghthRegex = new RegExp(
            "^([A-Za-z0-9\\s@#\\$%\\^&\\*\\(\\)_\\+\\-=\\[\\]\\{\\};:'\"`~,.<>\\/?!\\\\|]{1,30})$"
          );
          deliveryState[name + "Status"] = alphaNLenghthRegex.test(value.trim())
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          break;
        }
        case "customerAddress": {
          const alphaNLenghthRegex = new RegExp(
            "^([A-Za-z0-9\\s@#\\$%\\^&\\*\\(\\)_\\+\\-=\\[\\]\\{\\};:'\"`~,.<>\\/?!\\\\|]{1,40})$"
          );
          deliveryState[name + "Status"] = alphaNLenghthRegex.test(value.trim())
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          break;
        }
        case "contactPerson": {
          const alphaNLenghthRegex = new RegExp(
            "^([A-Za-z0-9\\s@#\\$%\\^&\\*\\(\\)_\\+\\-=\\[\\]\\{\\};:'\"`~,.<>\\/?!\\\\|]{1,30})$"
          );
          deliveryState[name + "Status"] = alphaNLenghthRegex.test(value.trim())
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          break;
        }
        case "contactNumber": {
          // const alphaNLenghthRegex = new RegExp("^\\+?[0-9()\\-\\s]{8,20}$");
          const alphaNLenghthRegex = new RegExp("^\\d{8}$");
          deliveryState[name + "Status"] = alphaNLenghthRegex.test(value.trim())
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          break;
        }
        case "deliveryDate": {
          const isValidDate = !isNaN(Date.parse(value));
          deliveryState[name + "Status"] = isValidDate
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          break;
        }
        case "role": {
          const alphaNLenghthRegex = new RegExp(
            "^([A-Za-z0-9\\s@#\\$%\\^&\\*\\(\\)_\\+\\-=\\[\\]\\{\\};:'\"`~,.<>\\/?!\\\\|]{1,30})$"
          );
          deliveryState[name + "Status"] = alphaNLenghthRegex.test(value.trim())
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          break;
        }
      }
      deliveryState[name] = value;
    }

    setDeliveryData(deliveryState);
  };

  //Handle Change for Products
  const handleProductChange = (index, event, selectEvent) => {
    const updatedProductData = [...productData];
    const currentItem = { ...updatedProductData[index] };

    // For MaterialSelect
    if (selectEvent?.name === "productName") {
      console.log(event, "event");

      const selectedCode = event?.value ?? "";

      // const selectedProduct = productOptions.find(
      //   (option) => option.value === selectedCode
      // );

      // currentItem.productCode = selectedProduct?.value ?? ""; // productCode
      currentItem.productName = selectedCode; // productName
    }

    // For MaterialInput
    if (event?.target) {
      const { name, value } = event.target;
      currentItem[name] = value;
    }

    updatedProductData[index] = currentItem;
    setProductData(updatedProductData);
  };

  //Submit validation check
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      deliveryData.salesOrderIdStatus === "success" &&
      deliveryData.customerNameStatus === "success" &&
      deliveryData.customerAddressStatus === "success" &&
      deliveryData.deliveryDateStatus === "success" &&
      deliveryData.deliveryAgentStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {formType == "add"
                      ? "Add Delivery Details"
                      : formType == "edit"
                      ? "Edit Delivery Details"
                      : "View Delivery Details"}
                  </MaterialTypography>
                </Stack>
                <Stack></Stack>
              </Stack>
            </>
          }
        />
        <CardContent sx={{ minHeight: "100vh" }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Delivery Information
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            {/* Grid Container */}

            <Grid container spacing={2}>
              {(formType === "edit" || formType === "view") && (
                <Grid size={{ lg: 6, xs: 12, sm: 12, md: 6 }}>
                  <MaterialBox>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Delivery ID
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="deliveryId"
                    value={deliveryData.deliveryId}
                    onChange={handleChange}
                    success={deliveryData.deliveryIdStatus === "success"}
                    error={deliveryData.deliveryIdStatus === "error"}
                    disabled={inputDisable}
                  />
                </Grid>
              )}
              <Grid size={{ lg: 6, xs: 12, sm: 12, md: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Sales Order ID
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  multiline
                  rows={4}
                  name="salesOrderId"
                  value={deliveryData.salesOrderId}
                  // value={soNumberOptions.find(opt => opt.value === deliveryData.salesOrderId) || null}
                  onChange={handleChange}
                  success={deliveryData.salesOrderIdStatus === "success"}
                  error={deliveryData.salesOrderIdStatus === "error"}
                  isDisabled={inputDisable}
                  options={soNumberOptions}
                />
                {deliveryData.salesOrderIdStatus === "error" && (
                  <FormControl>
                    <FormHelperText error>
                      Sales Order ID cannot exceed 50 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ lg: 6, xs: 12, sm: 12, md: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="customerName"
                  value={deliveryData.customerName}
                  onChange={handleChange}
                  success={deliveryData.customerNameStatus === "success"}
                  error={deliveryData.customerNameStatus === "error"}
                  disabled={true}
                />
                {deliveryData.customerNameStatus === "error" && (
                  <FormControl>
                    <FormHelperText error>
                      Customer Name cannot exceed 30 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ lg: 6, xs: 12, sm: 12, md: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Address <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="customerAddress"
                  value={deliveryData.customerAddress}
                  onChange={handleChange}
                  success={deliveryData.customerAddressStatus === "success"}
                  error={deliveryData.customerAddressStatus === "error"}
                  disabled={true}
                />
                {deliveryData.customerAddressStatus === "error" && (
                  <FormControl>
                    <FormHelperText error>
                      Customer Address cannot exceed 40 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ lg: 6, xs: 12, sm: 12, md: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Delivery Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="deliveryDate"
                  type="date"
                  value={deliveryData.deliveryDate}
                  onChange={handleChange}
                  success={deliveryData.deliveryDateStatus === "success"}
                  error={deliveryData.deliveryDateStatus === "error"}
                  disabled={true}
                  inputProps={{
                    min: today,
                  }}
                />
                {deliveryData.deliveryDateStatus === "error" && (
                  <FormControl>
                    <FormHelperText error>Invalid Delivery Date</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ lg: 6, xs: 12, sm: 12, md: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Person
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="contactPerson"
                  value={deliveryData.contactPerson}
                  onChange={handleChange}
                  success={deliveryData.contactPersonStatus === "success"}
                  error={deliveryData.contactPersonStatus === "error"}
                  disabled={inputDisable}
                />
                {deliveryData.contactPersonStatus === "error" && (
                  <FormControl>
                    <FormHelperText error>
                      Contact Person cannot exceed 30 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ lg: 6, xs: 12, sm: 12, md: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Person Number
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="contactNumber"
                  value={deliveryData.contactNumber}
                  onChange={handleChange}
                  success={deliveryData.contactNumberStatus === "success"}
                  error={deliveryData.contactNumberStatus === "error"}
                  disabled={inputDisable}
                />
                {deliveryData.contactNumberStatus === "error" && (
                  <FormControl>
                    <FormHelperText error>
                      {/* Contact Number should be between 8 to 15 characters */}
                      Contact Number should accept only 8 digits.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
            {productData.map((item, index) => {
              return (
                <MaterialBox mt={2} key={index}>
                  <div
                    style={{
                      border: "solid 1px black",
                      padding: "20px",
                      borderRadius: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, lg: 5.2, sm: 12, md: 5 }}>
                        <MaterialBox>
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Product Name <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                          name="productName"
                          onChange={(selected, meta) =>
                            handleProductChange(index, selected, meta)
                          }
                          // value={productOptions.find(opt => opt.value === item.productCode) || null}
                          value={item.productName}
                          options={productOptions}
                          menuPlacement="top"
                          isDisabled={true}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, lg: 5.2, sm: 12, md: 5 }}>
                        <MaterialBox>
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Quantity <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          name="quantity"
                          type="number"
                          value={item.quantity}
                          onChange={(e) => handleProductChange(index, e)}
                          isDisabled={true}
                        />
                      </Grid>
                      {productData.length > 1 && (
                        <Grid size={{ xs: 6, lg: 0.8, sm: 6, md: 1 }}>
                          <button
                            className="Delete-Button"
                            style={{ marginTop: "25px" }}
                            onClick={handleRemoveProduct}
                            disabled={inputDisable}
                          >
                            <Delete />
                          </button>
                        </Grid>
                      )}
                      <Grid size={{ xs: 6, lg: 0.8, sm: 6, md: 1 }}>
                        <button
                          className="Add-Button"
                          style={{ marginTop: "25px" }}
                          onClick={handleAddProduct}
                          disabled={inputDisable}
                        >
                          +
                        </button>
                      </Grid>
                    </Grid>
                  </div>
                </MaterialBox>
              );
            })}
            <Grid container spacing={2}>
              <Grid size={{ lg: 6, xs: 12, sm: 12, md: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Delivery Agent <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="deliveryAgent"
                  options={deliveryOptions}
                  value={deliveryData.deliveryAgent}
                  onChange={handleChange}
                  success={deliveryData.deliveryAgentStatus === "success"}
                  error={deliveryData.deliveryAgentStatus === "error"}
                  menuPlacement="top"
                  isDisabled={inputDisable}
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 12, sm: 12, md: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Role <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="role"
                  value={deliveryData.role}
                  onChange={handleChange}
                  success={deliveryData.roleStatus === "success"}
                  error={deliveryData.roleStatus === "error"}
                  disabled={true}
                />
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            size="small"
            onClick={() => navigate("/Manage-Deliveries")}
          >
            Cancel
          </MaterialButton>
          {formType != "view" && (
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              size="small"
              disabled={!checkAllFields()}
              onClick={formType == "add" ? handleSubmit : handleUpdate}
            >
              {formType == "add" ? "Submit" : "Update"}
            </MaterialButton>
          )}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default DeliveryForm;
